


























import _ from 'lodash';
import isGranted from '@/auth/isGranted';
import { HasTaskMixin } from '@/mixins';
import { updateNotes } from '@/email-campaign/email-campaign';
import { EmailCampaignNotes } from '@/types';

interface Data {
  value: string|null,
}

export default HasTaskMixin.extend({
  props: {
    emailCampaignId: {
      type: String,
      required: true,
    },
    notes: {
      type: Object as () => EmailCampaignNotes,
      required: true,
    },
  },
  data() {
    return {
      value: this.notes.value,
    };
  },
  computed: {
    isEmpty(): boolean {
      return _.isNil(this.value);
    },
  },
  watch: {
    value: {
      handler(): void {
        this.delayedSave();
      },
      immediate: true,
    },
  },
  methods: {
    save(): void {
      if (this.isEmpty) return;
      if (this.notes.value === this.value) return;
      const notes = _.cloneDeep(this.notes);
      notes.value = this.value;
      this.task = updateNotes(this.emailCampaignId, notes);
      this.task.then((emailCampaignNotes: EmailCampaignNotes) => {
        this.$emit('updated', emailCampaignNotes);
      });
    },
    delayedSave: _.debounce(function save(this: any) {
      this.save();
    }, 1500),
    isGranted,
  },
});
